import React from 'react';
import {render} from "react-dom";
import {FormStepperComponent} from '../form-page/FormStepper.component';
import {FormFooterComponent} from '../form-page/FormFooter.component';
import {SubjectLevelRowComponent} from './SubjectLevelRow.component';
import {FormValidator} from "../form-page/FormValidator";

export class VacancyPageController
{
    constructor() {
        this.service = 'VacancyService';
        this.sessionPage = parseInt(window.sessionStorage.getItem(this.service + 'FormPage') || 0);
        this.initialPage = this.sessionPage;
        this.$form = $('[data-controller="VacancyPageController"]').find('form');
        this.$steps = this.$form.find('.c-form-step');
        this.$fileInput = $('input[type="file"]');
        this.pages = ["Gegevens", "Contactgegevens", "Motivatie", "Opleiding", "Bijlesvakken"];

        // Validator is set in FormFooterComponent, but we need also it here to display errors
        this.validator = new FormValidator();

        // bind events
        this.$fileInput.on('change', e => this.updateInputFileLabel(e));

        // render
        this.renderReactFormComponents();
    }

    async renderReactFormComponents() {
        let courses;
        let levels;

        try {
            courses = await this.getCourses();
            levels = await this.getLevels();
        } catch (e) {
            this.validator.showError(e.responseText);
            return false;
        }

        render(
            <FormStepperComponent
                pages={this.pages}
                initialPage={this.initialPage}/>,
            $('FormStepperComponent')[0]
        );

        render(
            <FormFooterComponent
                pages={this.pages}
                $form={this.$form}
                service={this.service}
                initialPage={this.initialPage}/>,
            $('FormFooterComponent')[0]
        );

        render(
            <SubjectLevelRowComponent
                courses={courses}
                levels={levels}/>,
            $('SubjectLevelRowComponent')[0]
        );
    }


    getCourses(){
        return $.getJSON(wp.ajaxurl, {
            action: 'edpress_action',
            service: 'BijlesnetwerkApiService',
            method: 'getCourses',
            ajax: true,
            nonce: wp.ajax_nonce
        });
    }

    getLevels() {
       return $.getJSON(wp.ajaxurl, {
            action: 'edpress_action',
            service: 'BijlesnetwerkApiService',
            method: 'getLevels',
            nonce: wp.ajax_nonce
        });
    }

    /**
     * Update input label with filename
     * @param e
     */
    updateInputFileLabel(e) {
        let fileName = '';
        const $input = $(e.currentTarget),
            $label = $input.next('label'),
            labelVal = $label.innerHTML,
            files = e.currentTarget.files;

        if (files && files.length > 1 ) {
            /* istanbul ignore next */
            fileName = (e.currentTarget.getAttribute('data-multiple-caption') || '').replace('{count}', files.length);
        } else {
            fileName = e.target.value.split('\\').pop();
        }

        /* istanbul ignore next */
        $label.text((fileName) ? fileName : labelVal);
    }
}
